import Item from './Item.vue';
import { INSPECTION_ITEM_TYPE } from '@/_legacy/constants';

export default {
  functional: true,
  render(createElement, { props }) {
    return props.items.map((item, index) => createElement(Item, {
      key: item.uuid,
      props: {
        item,
        next: typeof (props.items[index + 1]) !== 'undefined' ? props.items[index + 1] : null,
        parent: item.type === INSPECTION_ITEM_TYPE.QUESTION ? props.parent?.uuid : props.parent,
        level: props.level + 1,
        onHeader: props.onHeader,
        onRepeated: props.onRepeated,
      },
    }));
  },
};
